import React, { useContext, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';

import Modal from '.';
import actions from './actions';

import {
  FeatureList,
  FeatureListItem,
  FeatureListCheckIcon,
  SignInButton,
  CreateAccountButton,
} from './styles';

const LoginPromoModal = ({ hideModalAction, onRequestClose, id, isOpen }) => {
  const { t } = useContext(AppContext);
  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onRequestClose={onRequestClose || hideModalAction}
      width={400}
    >
      <h3>{t('account', 'sign-in-promo.modal-title')}</h3>
      <FeatureList>
        <FeatureListItem>
          <FeatureListCheckIcon />
          {t('account', 'sign-in-promo.list-item-sync-your-info')}
        </FeatureListItem>
        <FeatureListItem>
          <FeatureListCheckIcon />
          {t('account', 'sign-in-promo.list-item-optimise-alerts')}
        </FeatureListItem>
        <FeatureListItem>
          <FeatureListCheckIcon />
          {t('account', 'sign-in-promo.list-item-organise-lists')}
        </FeatureListItem>
      </FeatureList>
      <SignInButton component={<Link to="/login" />}>
        {t('account', 'sign-in-promo.sign-in-button')}
      </SignInButton>
      <CreateAccountButton component={<Link to="/signup" />}>
        {t('account', 'sign-in-promo.create-account-button')}
      </CreateAccountButton>
    </Modal>
  );
};

const { func, string, bool } = PropTypes;

LoginPromoModal.propTypes = {
  hideModalAction: func,
  onRequestClose: func,
  id: string,
  isOpen: bool,
};

LoginPromoModal.defaultProps = {
  hideModalAction: undefined,
  onRequestClose: undefined,
  id: undefined,
  isOpen: false,
};

export default connect(null, { hideModalAction: actions.hideModal })(
  memo(LoginPromoModal)
);
